import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../../services/api.service';
import {LoginService} from '../../../services/login.service';
import {NotificationsService} from 'angular2-notifications';
import {ActivatedRoute} from '@angular/router';
import {ModalService} from '../../../services/modalService/modal.service';
import {OpenSessionsComponent} from '../zoomView/open-sessions/open-sessions.component';
import {ModalHelper} from '../../../services/modalService/modal.helper';
import {GoogleAnalyticsService} from "../../../services/google-analytics-service";
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-open-session',
  templateUrl: './open-session.component.html',
  styleUrls: ['./open-session.component.css', '../myreports.component.css']
})
export class OpenSessionComponent implements OnInit {

  ruid: string;
  isLicense: string;
  totalSessions = 0;
  count = 0;
  openSessions: any = [];
  isLoggedIn: boolean;
  currentUser: any;

  constructor(private apiService: ApiService,
              private ga: GoogleAnalyticsService,
              private loginService: LoginService,
              private route: ActivatedRoute,
              private notifications: NotificationsService,
              private modalHelper: ModalHelper,
              private modalService: ModalService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.loginService.isLoggedIn()
      .subscribe((currentUser) => {
          this.currentUser = currentUser;
          this.isLoggedIn = this.currentUser.isLoggedIn;
      });

    this.route.queryParams.subscribe(params => {
      if (params.ruid) {
        this.ruid = params.ruid;
        this.apiService.getSummary(this.ruid)
          .subscribe((res) => {
            this.isLicense = res.isLicense;
            if (!res.isLicense) {
              this.apiService.getOpenSessions(this.ruid)
                .subscribe((sessionsRes) => {
                  this.totalSessions = sessionsRes.sessionsTotalNr;
                  this.count = sessionsRes.sessionsNr;
                  this.openSessions = sessionsRes.sessions;
                }, (sessionsErr) => {
                    this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(sessionsErr, this.translate.instant('reports.sessionFail')));
                });
            }
          }, (error) => {
              this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(error, this.translate.instant('reports.invalidRuid')));
          });
      }
    });
  }

  loginPrompt() {
    this.modalHelper.openLogin({});
  }

  createAccount() {
  	this.ga.emitEvent('Reports Not Registereds', 'Create free account', 'Click');
    this.modalHelper.openCreate({}, null);
  }

  downloadCSV(xls) {
    this.ga.emitEvent('Reports Actions', 'Download CSV Report', 'Click');
    this.apiService.getCSV(this.ruid, 'OPEN', xls);
  }

  zoomView() {
    this.modalService.open(OpenSessionsComponent, {
      title: this.translate.instant('reports.openSessions.title'),
      data: {
        totalSessions: this.totalSessions,
        count: this.count,
        openSessions: this.openSessions,
        currentUser: this.currentUser
      }
    }).subscribe(model => {
    });
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/open-session/open-session.component.ts